<template>
  <div id="pdf-templates-page">
      <Header></Header>
      <PdfTemplatesTable :templates="templates" @updated="initialize"/>
  </div>
</template>

<script>
import PdfTemplate from "@/models/PdfTemplate";
import Header from "@/components/header.vue";
import PdfTemplatesTable from "@/components/admin/PdfTemplatesTable.vue";
export default {
    name: "pdf-templates-page",
    components: {
        Header,
        PdfTemplatesTable
    },
    data(){
        return {
            templates: []
        }
    },
    created() {
        this.initialize();
    },
    methods: {
        async initialize(){
            this.templates = await PdfTemplate.loadTemplates();
        }
    }
}
</script>

<style>

</style>